import i from './response.container';

export default i;
